import { render, staticRenderFns } from "./input-url.vue?vue&type=template&id=2bbe60e8&scoped=true&"
import script from "./input-url.vue?vue&type=script&lang=js&"
export * from "./input-url.vue?vue&type=script&lang=js&"
import style0 from "./input-url.vue?vue&type=style&index=0&id=2bbe60e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe60e8",
  null
  
)

export default component.exports